// extracted by mini-css-extract-plugin
module.exports = {"blue300":"#14267B","grey100":"#F2F2F7","grey200":"#E6E6EC","container":"SignupDocuments_container__DZ0uI","divider":"SignupDocuments_divider__wVhl4"};